import { ChangeDetectorRef, EventEmitter, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { ControlUser } from '../model/controlUser';
import { UserService } from '../service/user.service';
import { Log } from '../util/log';
import { AppComponent } from '../app.component';

@Component({
  selector: 'app-owners',
  templateUrl: './owners.component.html',
  styleUrls: ['./owners.component.css']
})
export class OwnersComponent implements OnInit {

  constructor(
    public appComponent: AppComponent,
    private cdRef: ChangeDetectorRef,
    private router: Router) {

  }

  ngOnInit(): void {

  }

  ngAfterViewInit() {

  }

  ngOnChanges(changes: SimpleChanges) {

  }

  onOwnerSelected(owner: ControlUser): void {

    Log.debug("onOwnerSelected: " + JSON.stringify(owner));

    this.router.navigate(['owner/' + owner.uid]);
  }

  addOwner(): void {

    this.router.navigate(['add-owner']);
  }

  isService(): boolean {
    return this.appComponent.isService();
  }


}